import { render, staticRenderFns } from "./trainingModulePageNew2.vue?vue&type=template&id=23b66156&scoped=true&"
import script from "./trainingModulePageNew2.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew2.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew2.vue?vue&type=style&index=0&id=23b66156&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b66156",
  null
  
)

export default component.exports